export const LIST_ALL = "/v1/appointment/appointment/list/all";

export const LIST_RESOURCE = "/v1/appointment/appointment/list/resource";

export const APPOINTMENT_DETAIL = "/v1/appointment/appointment/list/detail";

export const URL_CREATE_APPOINTMENT = "/v1/appointment/appointment/form/create";

export const URL_UPDATE_STATUS = "/v1/appointment/appointment/form/change-status";

export const URL_UPDATE_APPOINTMENT = "/v1/appointment/appointment/form/update";

export const URL_CREATE_BLOCK_TIME = "/v1/appointment/appointment/form/add-block-time";

export const URL_DELETE_BLOCK_TIME = "/v1/appointment/appointment/form/delete-block-time";

export const URL_CHECKOUT = "/v1/appointment/appointment/form/checkout";

export const URL_GET_APPOINTMENT_SPECIFIC_DATE = "/v1/appointment/appointment/list/specific-date";

export const URL_CHECK_UPDATE = "/v1/appointment/appointment/list/check-update";

export const LIST_SEARCH = "/v1/appointment/appointment/list/search";

export const DRAG_DROP_UPDATE_URL = "/v1/appointment/appointment/form/drag-drop-update";

export const URL_GET_DEPOSIT_LIST = "/v1/appointment/deposit/site/list";

export const URL_GET_DEPOSIT_DETAIL = "/v1/appointment/deposit/site/detail";

export const URL_MAKE_DEPOSIT_REFUND = "/v1/appointment/deposit/form/refund-stripe";

export const URL_RELOAD_DEPOSIT_LIST = "/v1/appointment/deposit/form/reload-list";

export const URL_CHARGE_DEPOSIT = "/v1/appointment/deposit/form/charge";

export const URL_EXPORT_APPOINTMENT = "/v1/appointment/appointment/site/export";

export const URL_INITIALIZE_PAYMENT = "/v1/appointment/deposit/form/initialize-payment";
export const URL_ADD_STRIPE_PAYMENT_METHOD = "/v1/appointment/deposit/form/add-stripe-payment-method";
